import { track } from '../tracking';
import { DOCS_APP_BE_URL, TOKEN_REFRESH } from './constants';

export const FLAVOUR = 'dw';

let accountDiffAlertTriggered = false;

const fetchWithRefresh = async (u: RequestInfo, options?: RequestInit) => {
    let url = u;
    if (typeof u === 'string') {
        const fl = new URLSearchParams({ flavour: FLAVOUR });

        if (u.indexOf('?') > -1) {
            url = `${url}&${fl}`;
        } else {
            url = `${url}?${fl}`;
        }
    }

    const headers = options?.headers ? new Headers(options.headers) : new Headers();

    // api manager
    if (url.toString().startsWith(DOCS_APP_BE_URL)) {
        headers.set('activeid', localStorage.getItem('activeId') || '');
    }

    const res = await fetch(url, { ...options, mode: 'cors', credentials: 'include', headers });

    if (res.status === 401) {
        const refreshApi = await fetch(TOKEN_REFRESH, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
        });

        if (!refreshApi.ok) {
            track('ERROR', { on: TOKEN_REFRESH, error: refreshApi.status.toString() });
        }

        if (refreshApi.status === 200) {
            const res = await fetch(url, {
                ...options,
                mode: 'cors',
                credentials: 'include',
                headers,
            });

            if (!res.ok) {
                track('ERROR', { on: url.toString(), error: res.status.toString() });
            }

            if (res.status === 401) {
                logout();
            }
            return res;
        } else {
            logout();
        }
    }

    if (!res.ok) {
        track('ERROR', { on: url.toString(), error: res.status.toString() });
    }

    // api manager
    if (url.toString().startsWith(DOCS_APP_BE_URL)) {
        if (res.status === 403) {
            const response = await res.json();
            if (response.code === 'DIFF') {
                if (accountDiffAlertTriggered) {
                    return res;
                }

                accountDiffAlertTriggered = true;

                // TODO bridge
                // re-discuss
                track('ACCOUNT_DIFF');
                alert('Change in account detected. Confirm reload of application.');
                window.location.replace('/app/init');
                return res;
            } else {
                accountDiffAlertTriggered = false;
            }
        }
    }

    return res;
};

export default fetchWithRefresh;

function logout() {
    // TODO call bridge
}
